module.exports = __webpack_public_path__ + "files/import-item-price-region.xlsx";